//个案工作台 对照录入


//引入接口文档
import req from '@/utils/req.js'

//获取对照录入列表数据
export function api_get_admin_files(params) {
    return req.post("/admin/patient-files/page", params);
}


//获取疾病类型/主要诊断
export function api_disease_type(params) {
    return req.get("/admin/disease-type",params);
}


// ------------对照录入-------------
//病历夹分页查询
export function pageMedicalFold(params) {
  return req.post("/admin/patient-case-history/page", params);
}

//病历夹分页查询
export function queryMedicalFold(params) {
  return req.post("/admin/patient-case-history/list", params);
}

//病历夹添加,并获取ID
export function addMedicalFold(params) {
  return req.post("/admin/patient-case-history/insertReturnId", params);
}

//对照录入OCR识别检验单
export function ocrRecord(params) {
  return req.post("/admin/ocr-record/ocr/add", params);
}

//ocr识别记录表详情
export function ocrRecordDetail(params) {
  return req.get(`/admin/ocr-record/${params}`);
}

//批量添加术语
export function insertTerminologyList(params) {
  return req.post("/admin/terminology/insertTerminologyList", params);
}

//批量添加术语
export function pageTerminologyList(params) {
  return req.post("/admin/terminology/page", params);
}

 //标准层级
 export function termListData(params) {
  return req.post("/admin/terminology/page", params);
} 

 //术语单位
 export function unitListData(params) {
  return req.get("/admin/category/parentId/100500", params);
}


//关联至编链
export function linkToScheme(params) {
  return req.post("/admin/scheme-time-axis/linkToScheme", params);
}

 //关联至编链下拉
 export function getRunTimeAxisList(params) {
  return req.get("/admin/scheme-time-axis/getListByPatientId", params);
}

//拍摄方位模糊搜索
export function api_shoot_orientation(params) {
  return req.get("/admin/category/shoot_orientation/children",params);
}

//部位方位模糊搜索
export function api_part_orientation(params) {
  return req.get("/admin/category/part_orientation/children",params);
}

//检查部位模糊搜索
export function api_operate_position(params) {
  return req.get("/admin/category/operate_position/children",params);
}

//获取检查项目模糊搜索
export function api_inspection(params) {
  return req.post("/admin/examine-info/list",params);
}
 //获取ocr识别记录
 export function getOcrLog(refId) {
  return req.get(`/admin/ocr-record/refId/${refId}`);
}


//禁用
export function disableInvalid(data1,data2) {
  return req.post(`/admin/patient-files-item/disable?disabled=${data1}&id=${data2}`);
}

//对照录入文件表列表查询
export function getPatientFilesItemList(params) {
  return req.post("/admin/patient-files-item/getPatientFilesItemList",params);
}

//检验检查数据添加
export function saveInspectRow(params) {
  return req.post("/admin/term-approval/save",params);
}


// ————————————————————2.0.7对照录入————————————————————————————————————
//病程事件新增
export function addArchivesEvent(params) {
  return req.post("/admin/archives-event/add",params);
}

//病程事件修改
export function updateArchives(params) {
  return req.post("/admin/archives-event/updateArchives",params);
}

//病程事件详情
export function archivesDetail(id) {
  return req.get(`/admin/archives-event/detail/${id}`);
}

//根据refId查询ocr识别前置处理后的记录
export function getOcrLogNew(refId) {
  return req.get(`/admin/ocr-record/new/refId/${refId}`);
}

//根据refId查询ocr预处理原始记录(右侧文本区域)
export function getOcrLogText(refId) {
  return req.get(`/admin/ocr-record/original/${refId}`);
}

//根据患者id查询(平台-重点指标计数)
export function getPatientFocusFieldPage(params) {
  return req.post("/admin/focusFieldConfig/getPatientFocusFieldPage",params);
}

//患者事件列表分页条件查询
export function archivesEventPage(params) {
  return req.get("/admin/archives-event/page",params);
}

//


//对照录入保存
export function saveCrossEntry(params) {
  return req.post('/admin/patient-files', params)
}

//病人管理（眼睛）查看对照录入
export function getNewByRefId(params) {
  return req.get('/admin/patient-files/getNewByRefId', params)
}

//分页搜索标准字段
export function pageStandardField(params) {
  return req.post('/admin/standard-field/page', params)
}

//根据重点字段项查询历史录入结果
export function getHistoryEvent(params) {
  return req.post('/admin/archives-event/getHistoryEvent', params)
}

//获取下拉字段的值
export function getSelectStandardValue(params) {
  return req.get('/admin/standard-field/getSelectValue', params)
}

//标记已读
export function readOtherEntry(params) {
  return req.get('/admin/patient-files-item/read', params)
}

//检验返回数据校验是否重点字段
export function inspectionInfoFocus(params) {
  return req.post('/admin/inspection-info/inspectionInfoFocus', params)
}

//判断标准字段是否重点字段
export function standardFiledFocus(params) {
  return req.post('/admin/standard-field/standardFiledFocus', params)
}

//标记重点
export function markFocus(params) {
  return req.get('/admin/patient-files-item/focus', params)
}

//根据诊疗事件记录id显示对照录入
export function getNewByEventMedicalId(params) {
  return req.get('/admin/patient-files/getNewByEventMedicalId', params)
}

//获取标本列表
export function getAllSpecimenTypeList(params) {
  return req.get('/biz/admin/inspection-info/getAllSpecimenTypeList', params)
}

//重点字段-对照录入搜索
export function getPatientFocusFieldSearchPage(params) {
  return req.post('/biz/admin/focusFieldConfig/getPatientFocusFieldSearchList', params)
}

//获取标本列表
export function push(params) {
  return req.get('/biz/admin/ocr-anomaly-index/push', params)
}

//推送图片
export function pushPic(params) {
  return req.get('/biz/admin/ocr-anomaly-index/pushPic', params)
}

//保存异常指标信息-不推送
export function noPushOcrAnomaly(params) {
  return req.post('/admin/ocr-anomaly-index', params)
}
